import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { EntityService } from '@services/core/entity.service';
import { map } from 'rxjs/operators';

export const officeResolver: ResolveFn<any> = () => {
  const entityService = inject(EntityService)

  return entityService.getOffices().pipe(
    map(offices => ({ offices, officesTemp: offices }))
  )
}
